import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';
import Button from '../Button';
import './style.css';

const ExportFilesModal = ({ show, onClose, onDownload }) => {
  return (
    <Modal centered show={show} onHide={onClose} className="ExportFilesModal" backdrop="static">
      <Modal.Header closeButton />
      <Modal.Body>
        <p className="ExportFilesModal-title">Click to download the three Bento survey files</p>
        <div className="ExportFilesModal-button-container">
          <Button onClick={onDownload} theme="dark" size="md" buttonText="Download files" />
        </div>
        <p className="ExportFilesModal-note">
          Note that your browser may ask you to allow multiple downloads from this site. If
          prompted, select Allow to download all three files. If only one file downloads, check your
          browser settings to make sure multiple or automatic downloads are allowed for this site.
        </p>
      </Modal.Body>
    </Modal>
  );
};

ExportFilesModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
};

export default ExportFilesModal;
